import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import Spinner from 'common/spinner/components/spinner';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Icon } from 'ui';
import {
  messageCenterStatusses,
} from 'utils/app-configs';
import moment from 'utils/cops-moment';
import { withRouter } from 'utils/withRouter';
import settingsConfig from '../../../settings/settings-config';
import { blockTypes } from '../../../utils/app-configs';
import { viewConfig } from '../../gantt/config';
import { viewIds } from '../../gantt/config/view';

const StyledTile = styled(Row)`
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  padding: 20px 10px;
  opacity: ${p => p.isdismissing === 1 && 0.5}
`;

const DateSpan = styled.span`
  color: rgba(0, 0, 0, 0.25);
  text-transform: lowercase;
  padding-left: 30px;
  font-weight: normal;
`;

const StyledText = styled.p`
  text-decoration: underline;
  cursor: pointer;
  font-size: 16px;
`;

const StyledIcon = styled(Icon)`
  color: ${p => p.color || 'black'};
`;

const LoadingIcon = styled(LoadingOutlined)`
  color: 'black';
  padding-left: 5px;
  cursor: 'pointer';
`;

const CloseIcon = styled(CloseOutlined)`
  color: 'black';
  padding-left: 5px;
  cursor: 'pointer';
`;

const StyledCol = styled(Col)`
  padding: 4px;
`;

const StyledTitle = styled.p`
  font-weight: 600;
  color: ${p => p.color};
  text-transform: uppercase;
  font-size: 16px;
  margin-bottom: 5px;
`;

// eslint-disable-next-line
const MessageTile = ({
  message,
  history,
  onRedirect,
  openPlanningAndView,
  onDismiss,
  intl,
  isDismissing,
  canDismiss,
}) => {
  const [status, setStatus] = useState({});
  useEffect(() => {
    if (message?.messageStatus) {
      setStatus(messageCenterStatusses?.find(s => s.status === message.messageStatus));
    }
  }, [message.messageStatus]);

  const handleClick = () => {
    onRedirect();
    if (message.entityType === blockTypes.workingHours) {
      const type = message.technicianInfo.current.type?.toLowerCase();
      let url = `/settings/working-hours/${type}`;
      if (type === settingsConfig.types.region) {
        const plant = message.technicianInfo.parents?.find(
          p => p.type === settingsConfig.types.plant,
        );
        url = `${url}/${plant.id}/${message.technicianInfo.current.id}`;
      } else if (type === settingsConfig.types.fse) {
        const plant = message.technicianInfo.parents?.find(
          p => p.type === settingsConfig.types.plant,
        );
        const region = message.technicianInfo.parents?.find(
          p => p.type === settingsConfig.types.region,
        );
        url = `${url}/${plant.id}/${region.id}/${message.technicianInfo.current.id}`;
      } else {
        url = `${url}/${message.technicianInfo.current.id}`;
      }
      history.push(url);
    } else if (message.entityType === blockTypes.holiday) {
      const type = message.technicianInfo.current.type?.toLowerCase();
      const url = `/settings/absence/${type}`;
      history.push(url, {
        holidayInfo: [message.technicianInfo.current, ...message.technicianInfo.parents],
      });
    } else if (blockTypes[message.entityType]) {
      openPlanningAndView({
        id: message.entityId,
        type: blockTypes[message.entityType],
        viewId: viewIds.oneWorkWeek,
        history,
        boardId: viewConfig.boardIdTypes.service,
        intl,
      });
    } else {
      history.push(`/${message.redirectUri}`, { context: message.entityId });
    }
  };

  const handleDismiss = () => {
    onDismiss({ id: message.correlationId });
  };

  return (
    <StyledTile isdismissing={isDismissing ? 1 : 0} data-test-id='message-tile'>
      <StyledCol span={2}>
        {status?.icon === 'spinner' ?
          <Spinner isIcon={true} />
          :
          <StyledIcon
            type={status?.icon || 'question-circle'}
            color={status?.color}
            className='fa-lg'
          />
        }
      </StyledCol>
      <Col span={19}>
        <StyledTitle color={status?.color}>
          {intl.formatMessage({ id: `message_center.${status?.title}` })}
          <DateSpan>
            {moment(message.operationDate).format('L LT')}
          </DateSpan>
        </StyledTitle>
        <StyledText
          data-test-id='message-tile.text'
          onClick={isDismissing || handleClick}
        >
          <FormattedMessage
            id='message_center.OPEN'
            values={{ type: message.entityTypeName, name: message.entityName }}
          />
        </StyledText>
      </Col>
      {canDismiss &&
        <Col span={3}>
          <StyledText onClick={isDismissing || handleDismiss}>
            {intl.formatMessage({ id: 'message_center.DISMISS' })}
            {isDismissing ? <LoadingIcon /> : <CloseIcon />}
          </StyledText>
        </Col>
      }
    </StyledTile>
  );
};

MessageTile.propTypes = {
  message: PropTypes.object,
  canDismiss: PropTypes.bool,
  intl: PropTypes.object,
  history: PropTypes.object,
  onRedirect: PropTypes.func,
  onDismiss: PropTypes.func,
  isDismissing: PropTypes.bool,
  openPlanningAndView: PropTypes.func,
};

export default withRouter(injectIntl(MessageTile));
